<template>
  <component :is="layout"></component>
  <LoginModal />
  <RegisterModal />
  <PasswordResetModal />
  <BusinessAccountLoginModal />
</template>

<script>
import foodLayout from './layouts/foodLayout.vue';
import profileLayout from './layouts/profileLayout.vue';
import mallLayout from './layouts/mallLayout.vue';
import mediaLayout from './layouts/mediaLayout.vue';
import emptyLayout from './layouts/emptyLayout.vue';
import publicationLayout from './layouts/publicationLayout.vue';
import LoginModal from '@/components/LoginModal.vue';
import RegisterModal from '@/components/RegisterModal.vue';
import PasswordResetModal from '@/components/modals/PasswordResetModal.vue';
import PageUpButton from '@/components/PageUpButton.vue';
import api from '@/api';
import { useAppStore } from '@/store';
import { mapState } from 'pinia';
import '@splidejs/vue-splide/css';
import BusinessAccountLoginModal from './components/BusinessAccountLoginModal.vue';
import { FEATURE_FLAGS } from '@/constants';
export default {
  components: {
    foodLayout,
    mallLayout,
    mediaLayout,
    emptyLayout,
    profileLayout,
    publicationLayout,
    LoginModal,
    RegisterModal,
    PasswordResetModal,
    BusinessAccountLoginModal,
    PageUpButton,
  },
  data() {
    return {
      store: useAppStore(),
      HABARLAR_ENABLED: FEATURE_FLAGS.HABARLAR,
    };
  },
  async created() {
    await this.checkAuth();
    await this.getLocations();
    await this.getSettings();
    await this.$store.getCatalogue();
    await this.checkOrderSessionId();
    await this.checkFoodOrderSessionId();
    await this.getPublicationCategories();
    await this.getMallCategories();
    if (this.HABARLAR_ENABLED) await this.getMediaCategories();
    await this.getExhibitionCategories();
    await this.getAccountCategories();
    await this.getBrands();
    await this.getReportTypes();
  },
  methods: {
    async checkAuth() {
      try {
        console.log('Token', localStorage.getItem('token'));

        const token = this.getToken;
        if (token !== null) {
          this.store.setState('authStatus', true);
          await this.store.getUserData();

          this.store.getLiked('publications');
          this.store.getLiked('mall');
          this.store.getLiked('exhibition');
          if (this.HABARLAR_ENABLED) this.store.getLiked('announcements');
          this.store.getLiked('videos');
          this.store.getLiked('business');
        }
      } catch (e) {
        console.log('checkAuth', e);
      }
    },

    async checkOrderSessionId() {
      try {
        let orderSessionId = this.getOrderSessionId;
        if (orderSessionId === null) {
          const response = await api.post('mall/order-sessions/');
          orderSessionId = response.data.id;
          this.store.setOrderSessionId(orderSessionId);
        } else {
          const response = await api.get(`mall/order-sessions/${orderSessionId}/`);
          this.store.setCart(response.data);
        }
        this.store.setState('orderSessionId', orderSessionId);
      } catch (e) {
        console.log(e);
      }
    },
    async checkFoodOrderSessionId() {
      try {
        let orderSessionId = this.getFoodOrderSessionId;
        if (orderSessionId === null) {
          const response = await api.post('exhibition/order-sessions/');
          orderSessionId = response.data.id;
          this.store.setFoodOrderSessionId(orderSessionId);
        } else {
          const response = await api.get(`exhibition/order-sessions/${orderSessionId}/`);
          this.store.setFoodCart(response.data);
        }
        this.store.setState('foodOrderSessionId', orderSessionId);
      } catch (e) {
        console.log(e);
      }
    },
    async getSettings() {
      // setting
      try {
        const response = await api.get('setting/');
        const data = response.data;
        this.store.setState('setting', data);
      } catch (e) {
        console.log(e);
      }
    },
    async getBrands() {
      try {
        const response = await api.get('mall/brands/', {
          params: { location: this.getLocation.id },
        });
        const data = response.data;
        this.store.setState('mallBrands', data);
      } catch (e) {
        console.log(e);
      }
    },
    async getPublicationCategories() {
      try {
        const response = await api.get('publications/categories/');
        const data = response.data;
        this.store.setState('publicationCategories', data);
      } catch (e) {
        console.log(e);
      }
    },
    async getMallCategories() {
      try {
        const response = await api.get('mall/categories/', {
          params: { location: this.getLocation.id },
        });
        const data = response.data;
        this.store.setState('mallCategories', data);
      } catch (e) {
        console.log(e);
      }
    },
    async getMediaCategories() {
      try {
        const response = await api.get('posts/announcements/categories/', {
          params: { location: this.getLocation.id },
        });
        const data = response.data;
        this.store.setState('mediaCategories', data);
      } catch (e) {
        console.log(e);
      }
    },
    async getExhibitionCategories() {
      try {
        const response = await api.get('exhibition/categories/', {
          params: { location: this.getLocation.id },
        });
        const data = response.data;
        this.store.setState('exhibitionCategories', data);
      } catch (e) {
        console.log(e);
      }
    },
    async getAccountCategories() {
      try {
        const response = await api.get('posts/business_accounts/categories/', {
          params: { location: this.getLocation.id },
        });
        const data = response.data;
        this.store.setState('accountCategories', data);
      } catch (e) {
        console.log(e);
      }
    },
    async getReportTypes() {
      try {
        const response = await api.get('comments/report_types/');
        const data = response.data.results;
        this.store.setState('reportTypes', data);
      } catch (e) {
        console.log(e);
      }
    },
    async getLocations() {
      try {
        const response = await api.get('locations/');
        const data = response.data;
        this.store.setState('locations', data);
        console.log(this.getLocation);
        if (this.getLocation) {
          this.store.setState('selectedLocation', this.getLocation);
        } else {
          this.store.setLocation(data[0]);
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
  computed: {
    ...mapState(useAppStore, ['getToken', 'getOrderSessionId', 'getFoodOrderSessionId']),
    layout() {
      return this.$route.meta?.layout || 'empty-layout';
    },
    getLocation() {
      return JSON.parse(localStorage.getItem('selectedLocation'));
    },
  },
};
</script>

<style scoped>
.logo {
  height: 6em;
  padding: 1.5em;
  will-change: filter;
  transition: filter 300ms;
}

.logo:hover {
  filter: drop-shadow(0 0 2em #646cffaa);
}

.logo.vue:hover {
  filter: drop-shadow(0 0 2em #42b883aa);
}
</style>
